export const deviationType = {
  deviationSuggestionBox: "DeviationSuggestionBox",
  deviationThreatsAndViolence: "DeviationThreatsAndViolence",
  deviationTrafficAndCustomerInfo: "DeviationTrafficAndCustomerInfo",
  deviationTrafficLog: "DeviationTrafficLog",
  deviationVastanhedePersonalInjuries: "DeviationVastanhedePersonalInjuries",
  deviationVastanhedeWorkingEnvironment: "DeviationVastanhedeWorkingEnvironment",
  deviationVastanhedeTrafficDisruption: "DeviationVastanhedeTrafficDisruption",
  deviationVehicleDamage: "DeviationVehicleDamage",
  deviationWorkingEnvironment: "DeviationWorkingEnvironment",
  gotlandSchoolBus: "DeviationGotlandSchoolBus",
}

export const deviationTemplateKey = {
  gotlandSchoolBus: "gotland_school_bus"
}
